import React from 'react';

import './no-data.component.scss';

const NoData = ({ noDataLabel, noDataTitle }) => (
	<div className="message-table">
		<div className="message-content">
			<div className="no-data">
				<p className="title">{noDataTitle || 'You have no data'}</p>
				<p className="sub-title">{noDataLabel || 'Try adjusting your search or filter to find what you’re looking for.'}</p>
			</div>
		</div>
	</div>
);

export default NoData;
